import React from "react";
import Row from "./project-single-row";
import styles from "./project-single.module.scss";
import theme from "../styles/theme.module.scss";

function ProjectRows(props) {
  return (
    <div className={`${styles.rows}`}>
      {props.rows && props.rows.map((node, key) => <Row key={key} {...node} />)}
    </div>
  );
}

export default ProjectRows;
